<template>
  <div>
    <sweet-modal ref="modal" width="70vw">
      <div class="row">
        <div class="col-sm-6">
          <big>{{ $t("ct-text-shadow-title") }}</big>
          <label class="label-range-custom">
            {{ $t("ct-text-shadow-h") }}
            <input
              type="range"
              class="custom-range"
              :min="min"
              :max="max"
              step="1"
              v-model="h"
              @change="changeValue"
              @mousemove="changeValue"
            />
            <input
              type="number"
              class="custom-input form-control"
              v-model="h"
              :min="min"
              :max="max"
              step="1"
              @change="changeValue"
              @keyup="changeValue"
              @mouseover="changeValue"
            />
          </label>
          <label class="label-range-custom">
            {{ $t("ct-text-shadow-v") }}
            <input
              type="range"
              class="custom-range"
              :min="min"
              :max="max"
              step="1"
              v-model="v"
              @change="changeValue"
              @mousemove="changeValue"
            />
            <input
              type="number"
              class="custom-input form-control"
              v-model="v"
              :min="min"
              :max="max"
              step="1"
              @change="changeValue"
              @keyup="changeValue"
              @mouseover="changeValue"
            />
          </label>
          <label class="label-range-custom">
            {{ $t("ct-text-shadow-b") }}
            <input
              type="range"
              class="custom-range"
              :min="minB"
              :max="max"
              step="1"
              v-model="b"
              @change="changeValue"
              @mousemove="changeValue"
            />
            <input
              type="number"
              class="custom-input form-control"
              v-model="b"
              :min="minB"
              :max="max"
              step="1"
              @change="changeValue"
              @keyup="changeValue"
              @mouseover="changeValue"
            />
          </label>
          <label>
            {{ $t("ct-text-shadow-c") }}
            <color-picker-component
              ref="colorPicker"
              class="text-shadow-color"
            ></color-picker-component>
          </label>
        </div>
        <div class="col-sm-6">
          <big>{{ $t("ct-text-shadow-title-preview") }}</big>
          <div class="preview-space-text-shadow d-flex align-items-center">
            <div class="preview-text" :style="{ textShadow: textShadow }">
              {{ textSelected }}
            </div>
          </div>
        </div>

        <p class="alert-info text-center">
          {{ $t("ct-text-shadow-note") }}
        </p>
        <!--          Note: Internet Explorer 9 and earlier do not support the text-shadow property.-->
      </div>
      <button
        slot="button"
        class="btn btn-outline-danger float-left ml-0"
        @click="resetValue"
      >
        {{ $t("ct-reset") }}
      </button>
      <button slot="button" class="btn btn-outline-info" @click="close">
        {{ $t("ct-cancel") }}
      </button>
      <button slot="button" class="btn btn-outline-success" @click="save">
        {{ $t("ct-select") }}
      </button>
    </sweet-modal>
  </div>
</template>
<script>

import {SweetModal} from "sweet-modal-vue";

import ColorPickerComponent from "./Abstract/ColorPicker";

export default {
  name: "TextShadowComponent",
  components: {
    ColorPickerComponent,
    SweetModal,
  },
  data() {
    return {
      element: null,
      value: "",
      labelDesc: "opa",
      callback: null,
      textSelected: "",
      minB: 0,
      min: -100,
      max: 100,
      h: 0,
      v: 0,
      b: 0,
      c: "#000000",
    };
  },
  computed: {
    textShadow() {
      return this.h + "px " + this.v + "px " + this.b + "px " + this.c;
    },
  },
  methods: {
    changeValue() {
      if (this.h < this.min) {
        this.h = this.min;
      }
      if (this.v < this.min) {
        this.v = this.min;
      }
      if (this.b < this.minB) {
        this.b = this.minB;
      }

      if (this.h > this.max) {
        this.h = this.max;
      }
      if (this.v > this.max) {
        this.v = this.max;
      }
      if (this.b > this.max) {
        this.b = this.max;
      }
    },

    save() {
      let style = this.h + "px " + this.v + "px " + this.b + "px " + this.c;

      this.callback(style, this.textSelected);
      this.$refs.modal.close();
      this.$root.$emit("blurEvent", true);
    },

    close() {
      this.$refs.modal.close();
      this.$root.$emit("blurEvent", true);
    },

    resetValue() {
      this.h = 0;
      this.v = 0;
      this.b = 0;
      this.c = "#000000";
      let newObj = {};
      let vm = this;
      newObj.defaultValue = this.c;
      newObj.callback = (value) => {
        vm.c = value;
        vm.changeValue();
      };
      this.$refs.colorPicker.setValues(newObj, true);
    },
  },
  mounted() {
    const isColor = (strColor) => {
      const s = new Option().style;
      s.color = strColor;
      return s.color !== "";
    };

    let vm = this;
    this.$root.$on("showTextShadowPopup", (text, styleBefore, callback) => {
      this.h = 0;
      this.v = 0;
      this.b = 0;
      this.c = "#000000";

      let styleSplit = styleBefore.split(")");

      if (isColor(styleSplit[0] + ")")) {
        this.c = styleSplit[0] + ")";

        let secondSplit = styleSplit[1].split(" ");

        this.h = parseInt(secondSplit[1]);
        this.v = parseInt(secondSplit[2]);
        this.b = parseInt(secondSplit[3]);
      } else {
        if (isColor(styleSplit[1] + ")")) {
          this.c = styleSplit[1] + ")";

          let secondSplit = styleSplit[0].split(" ");

          this.h = parseInt(secondSplit[0]);
          this.v = parseInt(secondSplit[1]);
          this.b = parseInt(secondSplit[2]);
        }
      }

      vm.textSelected = text;
      vm.callback = callback;

      vm.$refs.modal.open();

      let newObj = {};
      newObj.defaultValue = this.c;
      newObj.callback = (value) => {
        vm.c = value;
        vm.changeValue();
      };
      this.$refs.colorPicker.setValues(newObj, true);
    });
  },
};
</script>
<style lang="scss">
.text-shadow-color .vc-sketch {
  min-width: 185px;
  max-width: 185px;
}
</style>
<style scoped lang="scss">
.preview-text {
  margin: 0 auto;
}

.form-group {
  overflow: hidden;
}

.label-range-custom {
  display: inline-flex;
  width: 250px;
  margin-top: 10px;
}

.custom-range {
  width: 85px;
  margin-left: 10px;
  margin-right: 10px;
}

.custom-input {
  margin-top: -10px;
  width: 70px;
}

.preview-space-text-shadow {
  border: 1px solid #dee2e6;
  border-radius: 5px;
  text-align: center;
  background-color: white;
  height: 100%;
}

.alert-info {
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/TextShadow.vue